/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_Event_Groups_Restore_FailedInputs */

const en_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event groups failed to restore. ${i?.message}`)
};

const fr_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la restauration des groupes d’événements. ${i?.message}`)
};

const de_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen konnten nicht wiederhergestellt werden. ${i?.message}`)
};

const it_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile ripristinare i gruppi di eventi. ${i?.message}`)
};

const ru_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось восстановить группы событий. ${i?.message}`)
};

const es_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los grupos de eventos no se pudieron restaurar. ${i?.message}`)
};

const zh_cn2_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件组恢复失败。${i?.message}`)
};

const ja_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント グループの復元に失敗しました。${i?.message}`)
};

const hi_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट समूह पुनर्स्थापित करने में विफल रहे। ${i?.message}`)
};

const pt_pt2_automatic_save_event_groups_restore_failed = /** @type {(inputs: Automatic_Save_Event_Groups_Restore_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os grupos de eventos não puderam ser restaurados. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Event groups failed to restore. {message}" |
*
* @param {Automatic_Save_Event_Groups_Restore_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_event_groups_restore_failed = /** @type {((inputs: Automatic_Save_Event_Groups_Restore_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Event_Groups_Restore_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "de") return de_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "it") return it_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "ru") return ru_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "es") return es_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "ja") return ja_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "hi") return hi_automatic_save_event_groups_restore_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_event_groups_restore_failed(inputs)
	return en_automatic_save_event_groups_restore_failed(inputs)
});